import { makeStyles } from '@material-ui/core';
import { Button, CircularProgress } from '@material-ui/core';
import Alert from 'components/Alert';
import moment from 'moment';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import { customerFactory } from 'v2/services/customer';

interface IProps {
  alreadyJoinedBlackFridayChallenge: boolean;
  handleJoinBlackFriday: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
  },
  img: {
    width: '100%',
    height: 'auto',
  },
  buttonJoin: {
    backgroundColor: '#21afda',
    marginLeft: 8,
  },
  buttonLink: {
    backgroundColor: '#000',
    border: '1px solid #fff !important',
  },
  containerOver: {
    position: 'absolute',
    top: '50%',
    left: '45%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  colorPrimary: {
    color: '#fff',
  },
  loader: {
    marginTop: 2,
    marginLeft: 16,
    color: 'red',
  },
}));

const BlackFridayChallenge = memo(({ alreadyJoinedBlackFridayChallenge, handleJoinBlackFriday }: IProps) => {
  const [alreadyJoined, setAlreadyJoined] = useState(alreadyJoinedBlackFridayChallenge);
  const [loadingAction, setLoadingAction] = useState(false);

  const classes = useStyles();
  const currentYear = moment().format('YYYY');
  const isBlackFridayHappening = moment().isAfter(`${currentYear}-11-01T00:00:00Z`) && moment().isBefore(`${currentYear}-12-01T00:00:00Z`);
  const [joinBlackFriday] = useCallbackObservable(() => {
    setLoadingAction(true);
    return customerFactory.joinBlackFriday().pipe(
      tap(
        () => {
          toast.success('Sucesso, inscrição confirmada');
          setLoadingAction(false);
          setAlreadyJoined(true);
          handleJoinBlackFriday();
        },
        (err) => {
          setLoadingAction(false);
          toast.error(err);
        }
      )
    );
  }, []);

  useEffect(() => {
    setAlreadyJoined(alreadyJoinedBlackFridayChallenge);
  }, [alreadyJoinedBlackFridayChallenge]);

  const handleOpenConfirm = useCallback(async () => {
    const confirm = await Alert.confirm({
      message: `Tem certeza que deseja participar da ação de Black Friday ${currentYear}?`,
      buttonOk: 'Confirmar',
      small: true,
    });

    if (!confirm) {
      return;
    }

    joinBlackFriday();
  }, [currentYear, joinBlackFriday]);

  if (!isBlackFridayHappening) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.containerOver}>
        <Button
          variant='contained'
          classes={{ label: classes.colorPrimary }}
          className={classes.buttonLink}
          onClick={() => window.open('https://marketing.eduzz.com/black-friday-2022', '_blank')}
        >
          Acessar Black na Black
        </Button>

        {!alreadyJoined && (
          <Button
            onClick={handleOpenConfirm}
            variant='contained'
            classes={{ label: classes.colorPrimary }}
            disabled={loadingAction}
            className={classes.buttonJoin}
          >
            Quero participar
            {loadingAction && (
              <div className={classes.loader}>
                <CircularProgress size={16} classes={{ colorPrimary: classes.colorPrimary }} />
              </div>
            )}
          </Button>
        )}
      </div>
    </div>
  );
});

export default BlackFridayChallenge;
